// config base on the environment variable DEPLOY_ENV
let APIHOST = 'https://api-dev.workstream.is';
let INTERNALAPIHOST = APIHOST;
let BASEURL = 'https://jobs-dev.workstream.us';
let port = 4000;
let helloSignClientId = '1229905e27e23c3355cfe3c0e25c3cd3';
let skipDomainVerificationHelloSign = true;
let onboardingGACode = 'G-57T0VF50M7';
let careerPagesGACode = 'G-L7F97Y65ND';
const chatBotJsUrlLocal = 'http://localhost:8080/js/jobs.bundle.js';
const chatBotJsUrlDev = 'https://d25r1fhazfl3cm.cloudfront.net/js/jobs.workstream.chatbot.js';
const chatBotJsUrlStaging = 'https://d1uyj9v2g3f7ex.cloudfront.net/js/jobs.workstream.chatbot.js';
const chatBotJsUrlProd = 'https://d2efnp0ni3sb35.cloudfront.net/js/jobs.workstream.chatbot.js';
let chatBotJsUrl = chatBotJsUrlProd;

if (process.env.DEPLOY_ENV === 'develop') {
  APIHOST = 'https://api-dev.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-dev.workstream.is';
  BASEURL = 'https://jobs-dev.workstream.us';
  chatBotJsUrl = chatBotJsUrlDev;
}

if (process.env.DEPLOY_ENV === 'staging') {
  APIHOST = 'https://api-staging.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging.workstream.is';
  BASEURL = 'https://jobs-staging.workstream.us';
  port = 5000;
  helloSignClientId = '5a219c5403011d3eb59fda76c2c652db';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlStaging;
}

if (process.env.DEPLOY_ENV === 'staging-1') {
  APIHOST = 'https://api-staging-1.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging-1.workstream.is';
  BASEURL = 'https://jobs-staging-1.workstream.us';
  port = 6000;
  helloSignClientId = '3b412e4e99c925f49f8893c60cabe12a';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlDev;
}

if (process.env.DEPLOY_ENV === 'staging-2') {
  APIHOST = 'https://api-staging-2.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging-2.workstream.is';
  BASEURL = 'https://jobs-staging-2.workstream.us';
  port = 7000;
  helloSignClientId = 'c71a647d5b333464a97ca6f097c87fa9';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlDev;
}

if (process.env.DEPLOY_ENV === 'staging-3') {
  APIHOST = 'https://api-staging-3.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging-3.workstream.is';
  BASEURL = 'https://jobs-staging-3.workstream.us';
  port = 8000;
  helloSignClientId = 'b4b70fe61a3a6c26c5cf9be6ab947fe1';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlDev;
}

if (process.env.DEPLOY_ENV === 'staging-4') {
  APIHOST = 'https://api-staging-4.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging-4.workstream.is';
  BASEURL = 'https://jobs-staging-4.workstream.us';
  port = 3000;
  helloSignClientId = 'f2fce69f1167948fbd7d6599098503a0';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlDev;
}

if (process.env.DEPLOY_ENV === 'staging-seed') {
  APIHOST = 'https://api-staging-seed.workstream.us';
  INTERNALAPIHOST = 'https://internal-api-staging-seed.workstream.is';
  BASEURL = 'https://jobs-staging-seed.workstream.us';
  port = 3700;
  helloSignClientId = '4ce491dc03205c76115ed7226b9e3c1b';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlStaging;
}

if (process.env.DEPLOY_ENV === 'trunk') {
  APIHOST = 'https://api-trunk.workstream.us';
  // INTERNALAPIHOST = 'https://internal-api-trunk.workstream.is';
  INTERNALAPIHOST = APIHOST;
  BASEURL = 'https://jobs-trunk.workstream.us';
  port = 3800;
  helloSignClientId = '3830caf892ed60156f7d18ff054fa354';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlStaging;
}

if (process.env.DEPLOY_ENV === 'staging-qa') {
  APIHOST = 'https://api-stg-qa.staging.workstream.is';
  INTERNALAPIHOST = APIHOST;
  BASEURL = 'https://jobs-stg-qa.staging.workstream.us';
  port = 3900;
  helloSignClientId = '4ce491dc03205c76115ed7226b9e3c1b';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlStaging;
}

if (process.env.DEPLOY_ENV === 'sandbox') {
  APIHOST = 'https://api-sandbox.workstream.us';
  INTERNALAPIHOST = 'https://api-sandbox.workstream.us';
  BASEURL = 'https://jobs-sandbox.workstream.us';
  port = 9000;
  helloSignClientId = '8e48e3a39e8c7b188daeedd8ac3686e8';
  skipDomainVerificationHelloSign = false;
  chatBotJsUrl = chatBotJsUrlStaging;
}

if (process.env.DEPLOY_ENV === 'production') {
  APIHOST = 'https://api-backend.workstream.us';
  INTERNALAPIHOST = 'https://internal-api.workstream.is';
  BASEURL = 'https://www.workstream.us';
  helloSignClientId = 'f83ba7bc9a42dd1a16a4d50ae7c4d20a';
  skipDomainVerificationHelloSign = false;
  onboardingGACode = 'G-7MDK037DPV';
  careerPagesGACode = 'G-S92SY4T4XQ';
  INTERNALAPIHOST = APIHOST;
  chatBotJsUrl = chatBotJsUrlProd;
}

if (process.env.DEPLOY_ENV === 'local') {
  APIHOST = process.env.WS_API_BASE || 'http://localhost:3000';
  INTERNALAPIHOST = APIHOST;
  BASEURL = process.env.WS_JOBS_BASE || 'http://localhost:4000';
  skipDomainVerificationHelloSign = true;
  chatBotJsUrl = chatBotJsUrlLocal;
}

exports.APIHOST = APIHOST;
exports.INTERNALAPIHOST = INTERNALAPIHOST;
exports.BASEURL = BASEURL;
exports.port = port;
exports.skipDomainVerificationHelloSign = skipDomainVerificationHelloSign;
exports.helloSignClientId = helloSignClientId;
exports.onboardingGACode = onboardingGACode;
exports.careerPagesGACode = careerPagesGACode;
exports.chatBotJsUrl = chatBotJsUrl;
